export const DOCUMENT_SERVICE_ENDPOINT = {
    DOCUMENT: '/documentDetails'
  };